import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {PackingTypeReducerType} from "./Types";
import PackingType from "../../Models/PackingType";

const initialState: PackingTypeReducerType = {
  packingTypes: [],
  packingTypesOptionList:[]
}

const PackingTypeSlice = createSlice({
  name: "PackingType",
  initialState,
  reducers: {
    getPackingTypes(state) {},
    setPackingTypes(state, {payload}: PayloadAction<PackingType[]>) {
      state.packingTypes = payload;
      state.packingTypesOptionList = payload?.map((val) => ({value: val?._KEY, label:val?.name}))
    }
  }
});

export const PackingTypesActions = PackingTypeSlice.actions;
export default PackingTypeSlice.reducer;
